export enum SpreadsheetExportType {
  DeliveryForm = 0,
  DeliveryFormItem = 1,
  DeliveryFormItemRawMaterial = 2,
  FittingForm = 3,
  FittingFormItem = 4,
  FittingFormItemRawMaterial = 5,
  Quote = 6,
  QuoteItem = 7,
  Customer = 8,
  CustomerContact = 9,
  CustomerUserCustomer = 10,
  Manufacturer = 11,
  ManufacturerContact = 12,
  Item = 13,
  ItemRate = 14,
  ItemRawMaterial = 15,
  RawMaterial = 16,
  RawMaterialBatchNumber = 17,
  Shade = 18,
  ShadeRawMaterial = 19,
  ProForma = 20,
  ProFormaDeliveryForm = 21,
  ProFormaDeliveryFormItem = 22,
  ProFormaDeliveryFormItemRawMaterial = 23,
  Invoice = 24,
  InvoiceDeliveryForm = 25,
  InvoiceDeliveryFormItem = 26,
  InvoiceDeliveryFormItemRawMaterial = 27,
  Credit = 28,
  CreditDeliveryForm = 29,
  CreditDeliveryFormItem = 30,
  CreditDeliveryFormItemRawMaterial = 31,
  ItemFamily = 32,
  RawMaterialCategory = 33,
  ShadeGuide = 34,
  Rate = 35,
  MiscellaneousOperation = 36,
  Payment = 37,
  FiscalYear = 38,
  LaboratoryInformation = 39,
  LaboratoryInformationBank = 40,
  LaboratoryInformationContact = 41,
  All = 42,
  InvoiceUnpaidReminder = 43,
  InvoiceUnpaidReminderMailing = 44,
  CreditFreeLine = 45,
  InvoiceFreeLine = 46,
  LaboratoryUserCustomerSetting = 47,
  LaboratoryTax = 48,
  LaboratoryInformationDeliveryRoute = 49,
  WorkForm = 50,
  WorkFormItem = 51,
  WorkFormItemRawMaterial = 52,
  SimpleDeliveryForm = 53,
  SimpleFittingForm = 54,
  SimpleQuote = 55,
  SimpleWorkForm = 56,
  ItemRateComparison = 57,
  Sector = 58,
  LaboratoryResource = 59,
  LaboratoryResourceContact = 60,
  LaboratoryTaskNameSuggestion = 61,
  ItemLaboratoryTaskTemplate = 62,
  DeliveryFormItemLaboratoryTask = 63,
  FittingFormItemLaboratoryTask = 64,
  QuoteItemLaboratoryTask = 65,
  WorkFormItemLaboratoryTask = 66,
  SimpleDetailedDeliveryForm = 67,
  SimpleDetailedFittingForm = 68,
  SimpleDetailedQuote = 69,
  SimpleDetailedWorkForm = 70,
  InvoiceDeliveryFormItemLaboratoryTask = 71,
  ProFormaDeliveryFormItemLaboratoryTask = 72,
  LaboratoryRole = 73,
  UserLaboratory = 74,
  Patient = 75,
  ApiCredential = 76,
  PurchaseInvoice = 77,
  PurchaseCredit = 78,
  InvoiceList = 79,
  CreditList = 80,
  PaymentList = 81,
  MiscellaneousOperationList = 82,
  ProFormaList = 83,
}
